// React
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Libraries
import Joi from "joi";
import PropTypes from "prop-types";
import { Form, Button } from "semantic-ui-react";
import { isEmpty } from "lodash";

// Redux
import { connect } from "react-redux";
import { verifyPin } from "@Actions/authentication";

// Components
import Text from "@Components/Text";
import Input from "@Components/Input";

// Utils
import { getValidationErrors } from "@Utils";

// Styles
import styles from "./styles.module.css";

const VerifyPin = ({ dispatch }) => {
	const navigate = useNavigate();
	const defaultErrors = { pin: "" };
	const [pin, setPin] = useState("");
	const [errors, setErrors] = useState(defaultErrors);
	const schema = Joi.object().keys({
		pin: Joi.string().length(6).required().messages({
			"string.length": "Pin debe tener 6 caracteres",
			"string.empty": "Pin es un campo requerido",
		}),
	});

	const cleanupForm = () => {
		setPin("");
		setErrors(defaultErrors);
	};

	const handleInput = (e) => {
		const { value, name } = e.target;
		setErrors(defaultErrors);
		switch (name) {
			case "pin":
				setPin(value);
				break;
			default:
				break;
		}
	};

	const handleVerifyPin = () => {
		const validation = schema.validate({ pin }, { abortEarly: false });
		if (validation.error) {
			setErrors(getValidationErrors(validation, defaultErrors));
		} else {
			dispatch(verifyPin(pin, cleanupForm, navigate));
		}
	};

	return (
		<>
			<Text className={styles.infoTitle}>Ingrese el pin que fue enviado a su correo electrónico.</Text>
			<Form>
				<Input
					className={styles.input}
					label="Pin"
					placeholder="Pin"
					isPassword
					required
					autoComplete="off"
					error={!isEmpty(errors.pin) && { content: errors.pin, pointing: "above" }}
					name="pin"
					value={pin}
					onChange={handleInput}
					onKeyPress={handleVerifyPin}
				/>
			</Form>
			<Button className={styles.button} fluid onClick={handleVerifyPin}>
				Confirmar Pin
			</Button>
			<Text
				className={styles.titleLink}
				onClick={() => {
					return navigate("/auth/login", { replace: true });
				}}>
				Cancelar
			</Text>
		</>
	);
};

VerifyPin.propTypes = {
	dispatch: PropTypes.func,
};

export default connect()(VerifyPin);
